<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.ReportPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="ReportPopup"
      class="report-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div v-show="formType !== 'create'" class="del-btn" @click="delReport">
        删除
      </div>
      <div class="form-list">
        <van-field
          v-model="form.testProject"
          label="检测项目"
          name="检测项目"
          placeholder="请输入检测项目"
          :rules="rules.testProject"
        />
        <van-field
          v-model="form.testFacility"
          label="检测机构"
          name="检测机构"
          placeholder="请输入检测机构"
          :rules="rules.testFacility"
        />
        <van-field
          v-model="form.reportNo"
          label="检测编号"
          name="检测编号"
          placeholder="请输入检测编号"
          :rules="rules.reportNo"
        />
        <wh-field-time-popup
          v-model="form.issueDate"
          label="颁发日期"
          input-align="left"
          :rules="rules.issueDate"
        />
      </div>
      <div class="wh-flex-start img">
        <div>报告图片</div>
        <wh-upload v-model="form.photo" :max-count="3" />
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhUpload from '@/components/public/WhUpload/WhUpload'
export default {
  components: { WhPopup, WhFieldTimePopup, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      form: {
        issueDate: '',
        id: undefined,
        index: undefined,
        photo: [],
        reportNo: '',
        testFacility: '',
        testProject: ''
      },
      rules: {
        testProject: [{ required: true, message: '请输入检测项目' }],
        testFacility: [{ required: true, message: '请输入检测机构' }],
        reportNo: [{ required: true, message: '请输入检测编号' }],
        issueDate: [{ required: true, message: '请选择颁发日期' }]
      }
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增检测报告' : '编辑检测报告'
    }
  },
  methods: {
    open() {
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.formDataInit(this.form, this.initFormData)
      }
    },
    submitForm() {
      if (this.formType === 'create') {
        this.form.index = undefined
      }
      if (!this.form.photo.length) {
        this.$toast.fail('请添加图片')
        return
      }
      this.$emit('confirm', this.form)
      this.hidePopup()
    },
    delReport() {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        this.$emit('delfirm', this.form.index)
        this.hidePopup()
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.report-popup{
    padding: 10px 16px;
    position: relative;
    .del-btn{
      position: absolute;
      z-index: 10;
      top: -25px;
      right: 10px;
      color: red;
      font-size: 14px;
    }
    .img{
      padding: 10px 0 10px 16px;
      >div{
        height: 88px;
        font-size: 14px;
        color: #646566;
        margin-right: 10px;
      }
    }
}
</style>
